import { AnyAction } from 'redux';

import slice from '../reducer/slice';

const operation = (): AnyAction => slice.actions.setFilterStatusLoading();

export default operation;
